import React from 'react'
import { Flex, Grid, Paper, Stack } from '@mantine/core'
import { useParams } from 'react-router'
import { useGetLandingPageQuery } from '../redux/query/LandingPagesApi.slice'
import ErrorLoading from './../../../react/core/ErrorLoading'
import Loading from './../../../react/core/Loading'
import LandingPageRecentJobs from '../components/LandingPageRecentJobs'
import Banner from '../components/Banner'
import CompanyInformation from '../components/CompanyInformation'
import NotFound from '../../../react/core/NotFound'
import ScrollToTop from '../../../components/ScrollToTop'

const WIDTH = { base: '90%', md: '80%', lg: '60%' }
const MAX_WIDTH = '1170px'
const JOB_POSTING_COLS = { base: 12, md: 8 }
const ASIDE_COLS = { base: 12, md: 4 }

/**
 * Renders the expired job posting page.
 * @returns {JSX.Element}
 */
export default function ExpiredJobPosting () {
  const { landing_page_identifier: landingPageIdentifier } = useParams()
  const { data: landingPage, isError: landingPageIsError, isLoading: landingPageLoading } = useGetLandingPageQuery(landingPageIdentifier)

  if (landingPageIsError) {
    return <ErrorLoading />
  }

  if (landingPageLoading) {
    return <Loading />
  }

  document.title = 'Job listing expired'

  return (
    <>
      <ScrollToTop />
      <Flex
        gap='md'
        justify='center'
        align='center'
        direction='column'
        wrap='wrap'
        h='100%'
        pb='5em'
      >
        <Banner imageSrc={landingPage.header_image_banner} color={landingPage.header_banner_color} />
        <Grid w={WIDTH} maw={MAX_WIDTH} mt='-9.5vh'>
          <Grid.Col span={JOB_POSTING_COLS}>
            <Paper p='xl'>
              <NotFound height='100%' title='' message='This job listing has expired' />
            </Paper>
          </Grid.Col>
          <Grid.Col span={ASIDE_COLS}>
            <Stack>
              <CompanyInformation landingPage={landingPage} />
              <LandingPageRecentJobs landingPage={landingPage} />
            </Stack>
          </Grid.Col>
        </Grid>
      </Flex>
    </>
  )
}
